import React from 'react'
import './FeatureUnavailable.scss'

export interface FeatureUnavailableProps {
  message?: string
}

export const FeatureUnavailable: React.FC<FeatureUnavailableProps> = ({ message = 'This feature is not available in your package' }) => {
  return (
    <div className='d-flex flex-column gap-3 p-4 align-items-center zocks-border-0.75 border border-1 zocks-border-color-gray-100 zocks-bg-color-white feature-unavailable-container'>
      <div className='d-flex align-items-center justify-content-center zocks-bg-color-gray-100 feature-unavailable-circle'>
        <i className='bi bi-lock fs-4 zocks-text-gray-600' />
      </div>
      <h5 className='text-center mb-0'>{message}</h5>
    </div>
  )
}
